import "./stylebook.scss";

import "hc-offcanvas-nav/dist/hc-offcanvas-nav.carbon.css";

import "./components/ofcanvas/ofcanvas"


async function loadPrettier() {
  if (document.querySelectorAll(".language-html").length) {
    await import("./components/html-code-format/html-code-format")
    await import("./components/highlight-code/highlight-code")
  }
}
loadPrettier()
